module.exports = __webpack_public_path__ + "static/media/servicing3.92444a9d.jpg";